import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext';
import { isSessionForTenant } from '../lib/storefrontAuth';
import type { AuthSession } from '../types';

/** Auth scoped to the current tenant storefront (ignores JWT from another tenant). */
export function useStorefrontAuth(tenantSlug: string | null | undefined) {
  const auth = useAuth();

  return useMemo(() => {
    const session: AuthSession | null = isSessionForTenant(auth.session, tenantSlug)
      ? auth.session
      : null;

    return {
      session,
      loading: auth.loading,
      isGuest: !session,
      isClient: session?.type === 'client',
      isTenantStaff: session?.type === 'tenant_user',
      isPlatform: session?.type === 'platform',
      login: auth.login,
      completeDestination: auth.completeDestination,
      logout: auth.logout,
      refresh: auth.refresh,
    };
  }, [auth, tenantSlug]);
}
